import { createContext } from 'react'

import type { WorkspaceSettings } from '@/types/User'
import type { Squad } from '@/utils/squad'

const ctx: ctxType = {
  token: '',
  personId: '',
  personEmail: '',
  customerId: undefined,
  workspaceSettings: null,
  accessKey: '',
  squads: [],
  skillLevel: 1,
}

export interface ctxType {
  token?: string
  personId?: string
  personEmail: string
  customerId: string | undefined
  workspaceSettings: WorkspaceSettings | null
  squads: Squad[]
  accessKey: string
  skillLevel: number
}

const AppCtx = createContext(ctx)

export default AppCtx
